import { defineMessages } from 'react-intl';

export default defineMessages({
    appName: {
        id: 'portal.name',
        defaultMessage: 'Optim App'
    },
    faq: {
        id: 'portal.index.FAQ',
        defaultMessage: 'FAQ'
    },
    home: {
        id: 'app.html.index.Home',
        defaultMessage: 'Home'
    },
    additionalEnrollment: {
        id: 'portal.index.Additional Enrollment',
        defaultMessage: 'Additional Enrollment'
    },
    makeAPayment: {
        id: 'portal.index.Make a Payment',
        defaultMessage: 'Make a Payment'
    },
    billingSummary: {
        id: 'portal.index.Billing',
        defaultMessage: 'My Billing'
    },
    claimList: {
        id: 'portal.index.Claims',
        defaultMessage: 'My Claims'
    },
    claimDetails: {
        id: 'portal.index.Claim Details',
        defaultMessage: 'Claim Details'
    },
    createNote: {
        id: 'portal.index.Create Note',
        defaultMessage: 'Create Note'
    },
    policyChange: {
        id: 'portal.index.Policy Change',
        defaultMessage: 'Policy Change'
    },
    policyDetails: {
        id: 'portal.index.Policy Details',
        defaultMessage: 'My Policies'
    },
    accountInformation: {
        id: 'portal.index.Account Information',
        defaultMessage: 'Account Information'
    },
    homePage: {
        id: 'portal.index.Home Page',
        defaultMessage: 'Home Page'
    },
    error: {
        id: 'portal.index.Error',
        defaultMessage: 'Error'
    },
    errorMessage: {
        id: 'portal.index.Sorry, an error occurred. You can try later or contact one of our agents.',
        defaultMessage: 'Sorry, an error occurred. You can try later or contact one of our agents.'
    },
    backButton: {
        id: 'portal.index.Back',
        defaultMessage: 'Back'
    },
    documents: {
        id: 'portal.index.documents',
        defaultMessage: 'My Documents'
    },

    myAccount: {
        id: 'portal.index.My Account',
        defaultMessage: 'My Account'
    },
    goPaperlessHeading: {
        id: 'portal.index.Go Paperless',
        defaultMessage: 'Go Paperless'
    },
    myAGM: {
        id: 'portal.index.My AGM',
        defaultMessage: 'My AGM'
    },
});
